module.exports = __webpack_public_path__ + "img/egg-fill.306ac99c.svg";